<template>
  <div id="fleetlist">

    <div class="mb0 flx-jcc row row--columns flx-w flx-aifs ph row--spacing">
      <div class="col col--100-l col--20">
        <Filters :availableFilters="availableFilters" :filters="filters" />
      </div>
      <div class="col col--100-l col--80">
        <Search :search="search" @search="setSearch" @filter="onFilter" />

        <Fleetlist :fleetlist="pagedFleetlist" />

        <Paging v-if="paging.totalitems > paging.pagesize" :paging="paging" @paging="onPaging" />

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
const queryString = require('query-string')


import Filters from './components/Filters.vue'
import Fleetlist from './components/Fleetlist.vue'
import Paging from './components/Paging.vue'
import Search from './components/Search.vue'

export default {
  name: 'Fleet',
  data: function() {
    return {
      availableFilters: [
        {
          id: 'dwcc',
          name: 'DWCC',
          values: [
            {
              name: 'All',
              value: '',
              min: null,
              max: null,
              type: 'all'
            }, {
              name: '< 5.000',
              value: '0-5000',
              min: 0,
              max: 5000
            }, {
              name: '5.000 - 10.000',
              value: '5000-10000',
              min: 5000,
              max: 10000
            }, {
              name: '10.000 >',
              value: '10000',
              min: 10000,
              max: null
            }

          ]
        },
        {
          id: 'holdcapacity',
          name: 'Hold Capacity (CFT)',
          values: [
            {
              name: 'All',
              value: '',
              min: null,
              max: null,
              type: 'all'
            }, {
              name: '< 100.000',
              value: '100000',
              min: null,
              max: 100000
            }, {
              name: '100.000 - 200.000',
              value: '100000-200000',
              min: 100000,
              max: 200000
            }, {
              name: '200.000 - 300.000',
              value: '200000-300000',
              min: 200000,
              max: 300000
            }, {
              name: '300.000 - 400.000',
              value: '300000-400000',
              min: 300000,
              max: 400000
            }, {
              name: '400.000 - 500.000',
              value: '400000-500000',
              min: 400000,
              max: 500000
            }, {
              name: '500.000 - 600.000',
              value: '500000-600000',
              min: 500000,
              max: 600000
            }, {
              name: '600.000 - 700.000',
              value: '600000-700000',
              min: 600000,
              max: 700000
            }, {
              name: '700.000 - 800.000',
              value: '700000-800000',
              min: 700000,
              max: 800000
            }, {
              name: '800.000 - 900.000',
              value: '800000-900000',
              min: 800000,
              max: 900000
            }, {
              name: '> 900.000',
              value: '900000',
              min: 900000,
              max: null
            }

          ]
        },{
          id: 'gear',
          name: 'Gear',
          values: [
            {
              name: 'All',
              value: '',
              min: null,
              max: null,
              type: 'all'
            }, {
              name: 'Y',
              value: 'y',
              type: 'string'
            }, {
              name: 'N',
              value: 'n',
              type: 'string'
            }

          ]
        },
        {
          id: 'length',
          name: 'Length over all',
          values: [
            {
              name: 'All',
              value: '',
              min: null,
              max: null,
              type: 'all'
            }, {
              name: '< 50',
              value: '50',
              min: null,
              max: 50
            }, {
              name: '50 - 75',
              value: '50-75',
              min: 50,
              max: 75
            }, {
              name: '75 - 100',
              value: '75-100',
              min: 75,
              max: 100
            }, {
              name: '100 - 125',
              value: '100-125',
              min: 100,
              max: 125
            }, {
              name: '125 - 150',
              value: '125-150',
              min: 125,
              max: 150
            }, {
              name: '> 150',
              value: '150',
              min: 150,
              max: null
            }
          ]
        },
        {
          id: 'draught',
          name: 'Max. draught',
          values: [
            {
              name: 'All',
              value: '',
              min: null,
              max: null,
              type: 'all'
            }, {
              name: '< 4',
              value: '4',
              min: null,
              max: 4
            }, {
              name: '4 - 5',
              value: '4-5',
              min: 4,
              max: 5
            }, {
              name: '5 - 6',
              value: '5-6',
              min: 5,
              max: 6
            }, {
              name: '6 - 7',
              value: '6-7',
              min: 6,
              max: 7
            }, {
              name: '7 - 8',
              value: '7-8',
              min: 7,
              max: 8
            }, {
              name: '8 - 9',
              value: '8-9',
              min: 8,
              max: 9
            }, {
              name: '> 9',
              value: '9',
              min: 9,
              max: null
            }
          ]
        }, {
          id: 'iceclass',
          name: 'Ice class',
          values: [
            {
              name: 'All',
              value: '',
              min: null,
              max: null,
              type: 'all'
            }, {
              name: 'IA',
              value: 'ia',
              type: 'string'
            }, {
              name: 'IB',
              value: 'ib',
              type: 'string'
            }, {
              name: 'IC',
              value: 'iC',
              type: 'string'
            }, {
              name: 'ID',
              value: 'id',
              type: 'string'
            }, {
              name: 'IE',
              value: 'ie',
              type: 'string'
            }, {
              name: 'II',
              value: 'ii',
              type: 'string'
            }, {
              name: 'III',
              value: 'iii',
              type: 'string'
            }, {
              name: 'IAS',
              value: 'ias',
              type: 'string'
            }, {
              name: 'NO ICE',
              value: 'no ice',
              type: 'string'
            }

          ]
        }
      ],
      filters: {
        dwcc: null,
        holdcapacity: null,
        length: null,
        draught: null,
        gear: null,
        iceclass: null
      },
      fleetlist: [],
      initialized: false,
      paging: {
        pagesize: 25,
        currentpage: 0,
        totalitems: 0,
      },
      search: '',
    }
  },
  beforeMount: function() {
    // Parse querystring variables
    let query = queryString.parse(location.search)
    this.search = query.search ? query.search : ''
    this.filters.dwcc = query.dwcc ? this.availableFilters.find(x => x.id === 'dwcc').values.find(x => x.value === query.dwcc) : this.availableFilters.find(x => x.id === 'dwcc').values[0]
    this.filters.holdcapacity = query.holdcapacity ? this.availableFilters.find(x => x.id === 'holdcapacity').values.find(x => x.value === query.holdcapacity) : this.availableFilters.find(x => x.id === 'holdcapacity').values[0]
    this.filters.length = query.length ? this.availableFilters.find(x => x.id === 'length').values.find(x => x.value === query.length) : this.availableFilters.find(x => x.id === 'length').values[0]
    this.filters.draught = query.draught ? this.availableFilters.find(x => x.id === 'draught').values.find(x => x.value === query.draught) : this.availableFilters.find(x => x.id === 'draught').values[0]
    this.filters.gear = query.gear ? this.availableFilters.find(x => x.id === 'gear').values.find(x => x.value === query.gear) : this.availableFilters.find(x => x.id === 'gear').values[0]
    this.filters.iceclass = query.iceclass ? this.availableFilters.find(x => x.id === 'iceclass').values.find(x => x.value === query.iceclass) : this.availableFilters.find(x => x.id === 'iceclass').values[0]
    this.paging.currentpage = query.page ? parseInt(query.page) : 0
  },
  mounted: function() {
    axios.get('api/ships').then(response => {
      this.fleetlist = response.data.ships
      this.paging.totalitems = this.filteredFleetlist && this.filteredFleetlist.length

      this.initialized = true

    })
  },
  computed: {
    /**
     * @description Return all projects that pass the filter
     */
    filteredFleetlist: function() {
      var searchTerm = this.search.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      
      return this.fleetlist.filter(ship => {
        let shouldFilter = false
        let include = true

        for (let filterKey in this.filters) {
          let filter = this.filters[filterKey]
          if (filter && include) {
            shouldFilter = true


            if (filter.type === 'string') {
              // console.log(`Ship: ${ship[filterKey].toLowerCase()}; filter: ${filter.value.toLowerCase()}`)
              include = (ship[filterKey].trim().toLowerCase() === filter.value.toLowerCase())
            } else {
              // console.log(`key: ${ship[filterKey]} - min: ${filter.min} - max: ${filter.max}`)
              include = (filter.min === null || ship[filterKey] >= filter.min) && (ship[filterKey] <= filter.max || filter.max === null)
            }
          }
        }

        if (include && this.search !== '') {
          shouldFilter = true
          var shipName = ship.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          include = include && (shipName.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0)
        }

        if (shouldFilter) {
          return include
        }

        return true
      })
    },

    /**
     * @description Return a paged set of projects
     */
    pagedFleetlist: function() {
      return this.filteredFleetlist.slice(
        this.paging.pagesize * this.paging.currentpage,
        this.paging.pagesize * (this.paging.currentpage + 1)
      )
    },
  },
  methods: {
    /**
     * @description Build a new querystring with the selected filters and push it to the history state
     */
    updateQueryString: function() {
      let query = {}
      query.search = this.search !== '' ? this.search : undefined
      query.dwcc = this.filters.dwcc && this.filters.dwcc.value !== ''  ? this.filters.dwcc.value : undefined
      query.holdcapacity = this.filters.holdcapacity && this.filters.holdcapacity.value !== ''  ? this.filters.holdcapacity.value : undefined
      query.length = this.filters.length && this.filters.length.value !== ''  ? this.filters.length.value : undefined
      query.draught = this.filters.draught && this.filters.draught.value !== ''  ? this.filters.draught.value : undefined
      query.gear = this.filters.gear && this.filters.gear.value !== ''  ? this.filters.gear.value : undefined
      query.iceclass = this.filters.iceclass && this.filters.iceclass.value !== ''  ? this.filters.iceclass.value : undefined
      query.page = this.paging.currentpage > 0 ? this.paging.currentpage : undefined

      this.$router.push({ query: query })
    },
    /**
     * @description Set the current search query
     */
    setSearch: function(val) {
      this.search = val
      this.updateQueryString()
    },
    /**
     * @description Reset the paging properties after changing a filter or search query
     */
    onFilter: function() {
      this.paging.currentpage = 0
      this.paging.totalitems =
        this.filteredFleetlist && this.filteredFleetlist.length
    },
    /**
     * @description Navigate to the top of the projects-div after changing paging
     */
    onPaging: function() {
      this.updateQueryString()
    }
  },
  watch: {
    /**
     * @description Watch for change of the filters. Trigger a querystring update, and reset paging
     */
    filters: {
      handler() {
        this.updateQueryString()
        if (this.initialized) {
          this.paging.currentpage = 0
        }
        this.paging.totalitems = this.filteredFleetlist && this.filteredFleetlist.length
      },
      deep: true,
    },
  },
  components: {
    Filters,
    Fleetlist,
    Paging,
    Search
  }
}
</script>
